import { createContext } from 'react';

export const TokenSenderContext = createContext({});
